// Every design, by job and family, and the layouts by id. Names and first
// words live with the jobs in data/postTypes.js; this is only the drawing.
import editorial from './editorial'
import poster from './poster'
import quiet from './quiet'
import { LAYOUTS } from './layouts'
import { isSeasonal } from '../../kits'
import { drawSeasonal } from '../../kits/draw'

const DRAW = { editorial, poster, quiet }

export const drawDesign = (p, env) => {
  if (env.post.family === 'layouts' && isSeasonal(env.post.layout)) {
    drawSeasonal(p, env)
    return
  }
  if (env.post.family === 'layouts' && LAYOUTS[env.post.layout]) {
    LAYOUTS[env.post.layout](p, env)
    return
  }
  const family = DRAW[env.post.family] || editorial
  const draw = family[env.post.type] || family.freshWork
  draw(p, env)
}
